import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
import { getStoreData, getStoreDataFromLocal } from '../utils/functions';




const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const EditPromotion = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const location = useLocation();

    const [startDate, setStartDate] = useState(new Date());
    const { state, setStoreData } = useContext(Context)

    const [selectedDate, setSelectedDate] = useState()
    const [loading, setLoading] = useState(false)
    const [promotionData, setPromotionData] = useState({
        prom_name: location?.state?.data?.prom_name,
        prom_type: location?.state?.data?.prom_type,
        prom_start_date: location?.state?.data?.prom_start_date,
        prom_end_date: location?.state?.data?.prom_end_date,
        prom_msg: location?.state?.data?.prom_msg,
    })

    const [prom_amount, setProm_amount] = useState(location?.state?.data?.prom_amount) //discount price enter by user
    const [prom_qty, setProm_qty] = useState(location?.state?.data?.prom_qty)
    const [promPrice, setPromPrice] = useState(location?.state?.data?.prom_price) //calculated promotion price



    function formatDate(dateObj) {
        var month = dateObj.getMonth() + 1;
        var dat = dateObj.getDate();
        if (month < 10) month = "0" + month;
        if (dat < 10) dat = "0" + dat;
        let date = dateObj.getFullYear() + "-" + month + "-" + dat;
        return date;
    }

    function calculatePrice(qty) {

        var prodPrice = parseInt(location?.state.prodData.p_MSRP);
        var prom_price = parseInt(prom_amount);

        if (!qty) {
            qty = prom_qty
        }
        // var qty = qty;
        if (promotionData.prom_type == 'fixed') {

            var price = (qty * prodPrice) - (prom_price);
            setPromPrice(price)
        }
        else {
            var percentPrice = ((prodPrice * qty) / 100) * prom_price;
            var price = (qty * prodPrice) - (percentPrice);
            setPromPrice(price)


        }

    }

    function editPromotion() {

        if (promotionData.prom_name == '') {
            alert('Please enter promotion title')
            return
        }
        if (promotionData.prom_type == '') {
            alert('Please enter promotion type')
            return
        }
        if (prom_amount == '') {
            alert('Please enter discount price')
            return
        }
        if (prom_qty == '' || prom_qty == '0') {
            alert('Please enter promotion quantity')
            return
        }
        if (promotionData.prom_start_date == '') {
            alert('Please enter promotion start data')
            return
        }
        if (promotionData.prom_end_date == '') {
            alert('Please enter promotion end data')
            return
        }

        const reqObj = {
            prom_name: promotionData.prom_name,
            prom_type: promotionData.prom_type,
            prom_amount: prom_amount, //discount price
            prom_qty: prom_qty,
            prom_price: promPrice,
            prom_start_date: promotionData.prom_start_date,
            prom_end_date: promotionData.prom_end_date,
            prom_msg: promotionData.prom_msg,
            prom_id: location?.state?.data?.prom_id,
        }
        console.log(reqObj)

        setLoading(true)
        apiRequest(reqObj, 'editPromotion')
            .then(data => {
                setLoading(false)
                console.log(data)
                if (data.status == 1) {
                    alert('Promotion Updated')
                    history.replace('/managePromotion'
                        // p_id : location.state.prodData.p_id
                    )
                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })



    }

    useEffect(() => {
        console.log('location = ')
        console.log(location.state)
    }, [])


    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >
                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">Edit Promotion</h1>
                                            </div>
                                            <div className="row">
                                                {/* <form id="frm_customer"> */}

                                                <div className="col-sm-3">
                                                    <div className="editDetails" style={{ fontSize: 13.5, }}>Product Name</div>
                                                    <input

                                                        type="text"
                                                        value={location.state?.prodData?.p_name}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={location.state?.prodData?.p_name}
                                                    />
                                                    <br />
                                                </div>
                                                <div className="col-sm-2" style={{ fontSize: 13 }}>
                                                    <div className="editDetails" >Product Price</div>
                                                    <input
                                                        type="text"
                                                        value={location?.state?.prodData?.p_MSRP}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={location.state?.prodData?.p_MSRP}
                                                    />
                                                    <br />
                                                </div>



                                                <div className="col-sm-2">
                                                    <div className="editDetails" style={{ fontSize: 13 }} >Actual Price</div>
                                                    <input
                                                        type="text"
                                                        value={prom_qty ? location?.state.prodData.p_MSRP * prom_qty : location?.state?.prodData?.p_MSRP * location?.state?.data?.prom_qty}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={location?.state?.prodData?.p_MSRP * location?.state?.data?.prom_qty}
                                                    />
                                                    <br />
                                                </div>

                                                <div className="col-sm-2">
                                                    <div className="editDetails" style={{ fontSize: 13 }} >Discounted Price</div>
                                                    <input
                                                        type="text"
                                                        value={promPrice}
                                                        disabled={true}
                                                        className="form-control form-control-user"
                                                        placeholder={promPrice}
                                                    />
                                                    <br />
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className="editDetails" >Promotion Message</div>
                                                    <textarea
                                                        style={{ minHeight: 49 }}
                                                        type="textarea"
                                                        className="form-control form-control-user"
                                                        // placeholder="Promotion Title"
                                                        value={promotionData.prom_msg}
                                                        onChange={(t) => {
                                                            setPromotionData({
                                                                ...promotionData,
                                                                prom_msg: t.target.value
                                                            })
                                                        }}

                                                    />
                                                    <br />
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-sm-6">
                                                        <div className="editDetails" >Promotion Title</div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-user"
                                                            placeholder="Promotion Title"
                                                            value={promotionData.prom_name}
                                                            onChange={(t) => {
                                                                setPromotionData({
                                                                    ...promotionData,
                                                                    prom_name: t.target.value
                                                                })
                                                            }}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="center col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Discount type</div>
                                                        <select
                                                            title="Discount type"
                                                            className="form-control form-control-user"
                                                            placeholder="Discount type"
                                                            value={promotionData.prom_type}
                                                            onChange={(v) => {
                                                                setPromotionData({
                                                                    ...promotionData,
                                                                    prom_type: v.target.value
                                                                })
                                                                setProm_amount('')
                                                                setPromPrice('')
                                                                setProm_qty('')

                                                            }}
                                                        >
                                                            <option value="percent">Percent</option>
                                                            <option value="fixed">Fixed Amount </option>
                                                        </select>
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Discount</div>

                                                        <input
                                                            type="number"
                                                            className="form-control form-control-user"
                                                            placeholder="Discount"
                                                            value={prom_amount}
                                                            onBlur={() => {
                                                                if (prom_qty) {
                                                                    calculatePrice()
                                                                }
                                                            }}
                                                            onChange={(t) => {

                                                                if (promotionData.prom_type == 'fixed') {
                                                                    if (parseInt(t.target.value) > parseInt(location.state?.prodData?.p_MSRP)) {
                                                                        alert(`promotion price must be less than ${location.state.p_MSRP}`)
                                                                        return
                                                                    }
                                                                    setProm_amount(t.target.value)
                                                                }
                                                                else {
                                                                    if (t.target.value > 100) {
                                                                        alert('percent cannot be greater than 100')
                                                                        return
                                                                    }
                                                                    setProm_amount(t.target.value)

                                                                }
                                                                // forceUpdate();

                                                            }}
                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails"  >Promotion Quantity</div>
                                                        <input
                                                            type="number"
                                                            disabled={prom_amount ? false : true}
                                                            className="form-control form-control-user"
                                                            placeholder="Promotion Quantity"
                                                            value={prom_qty}

                                                            onBlur={(v) => {
                                                                calculatePrice(v.target.value)
                                                            }}
                                                            onChange={(t) => {
                                                                setProm_qty(t.target.value)
                                                                calculatePrice(t.target.value)

                                                            }}
                                                        />
                                                        <br />
                                                    </div>

                                                    <div
                                                        className="col-sm-6 mb-3 mb-sm-0"
                                                    >
                                                        <div className="editDetails" >Start data</div>
                                                        <DatePicker
                                                            className="form-control form-control-user"
                                                            placeholderText="Start Date"
                                                            value={promotionData.prom_start_date}
                                                            selected={selectedDate}
                                                            onChange={(date) => {
                                                                setSelectedDate(date)
                                                                setPromotionData({
                                                                    ...promotionData,
                                                                    prom_start_date: formatDate(date)
                                                                })
                                                            }}
                                                        />

                                                        <br />
                                                    </div>
                                                    <div
                                                        className="col-sm-6 mb-3 mb-sm-0"
                                                    >
                                                        <div className="editDetails" >End date</div>
                                                        <DatePicker
                                                            className="form-control form-control-user"
                                                            placeholderText="End date"
                                                            value={promotionData.prom_end_date}
                                                            onChange={(date) => {
                                                                setSelectedDate(date)
                                                                setPromotionData({
                                                                    ...promotionData,
                                                                    prom_end_date: formatDate(date)
                                                                })
                                                            }}
                                                        />
                                                        <br />
                                                    </div>

                                                </div>




                                                {/* </div> */}

                                                {/* <div className="col-sm-6 mb-3 mb-sm-0">
                                                    <div className="editDetails" > </div>
                                                    <input
                                                        type="number"
                                                        value={}
                                                        className="form-control form-control-user"
                                                        disabled={true}
                                                    />
                                                    
                                                </div> */}
                                                <Button
                                                    id="add_customer"
                                                    className="rBBtn"
                                                    onClick={() => editPromotion()}
                                                    style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                                >
                                                    Save
                                                </Button>
                                                {/* </form> */}
                                            </div>
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>
                            {/* End of Page Wrapper */}
                            {/* Scroll to Top Button*/}
                            <a className="scroll-to-top rounded" href="#page-top">
                                <i className="fas fa-angle-up" />
                            </a>
                            {/* Logout Modal*/}
                            <div
                                className="modal fade"
                                id="logoutModal"
                                tabIndex={-1}
                                role="dialog"
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                Ready to Leave?
                                            </h5>
                                            <button
                                                className="close"
                                                type="button"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            Select "Logout" below if you are ready to end your current session.
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                data-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                            <a className="btn btn-primary" href="logout.php">
                                                Logout
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default EditPromotion
